import { empty } from './Helpers';

/**
 * Looking for app address
 *
 * @param data
 * @returns {Promise<string|boolean>}
 */
export default async function handleLogin (data) {

    let error = false;

    try {

        // 1. fetch information about given NID
        const connectionInformation = await fetch('https://appgw.magaya.net/connection/' + data.networkId + '?app=wms')

        let connection = await connectionInformation.json();
        connection.connection = connection.connection ?? false;

        // 2. trying redirect
        if (connection.connection) {
            const destinationUrl = connection.connection + '/flow/';

            // auto redirect for non secure HTTP
            if (connection.connection.substr(0,5)==='http:') {
                window.location.href = destinationUrl;
                return true;
            }

            // 3. ping the app
            const ping = await fetch(connection.connection + '/ping')

            // 4. redirect to app
            if (ping.status === 200) {

                // backend is up
                const info = await fetch(connection.connection + '/info');

                // old backends dont have status information
                if  (info.status === 200) {
                    const infoData = await info.json();

                    // old backends dont have NID information
                    if (!empty(infoData.company.networkId)) {

                        // check app status
                        const destinationStatus = await fetch(destinationUrl);

                        // redirect
                        if (destinationStatus.status === 200) {
                            window.location.href = destinationUrl;
                            return true;
                        }

                        // something happens
                        error = 'Destination is not accessible, contact your system administrator';

                    } else {
                        error = 'Update your backend';
                    }
                } else  {
                    error = 'Update your backend';
                }
            } else {
                // backend is down
                error = 'Connection error, contact your system administrator';
            }
        } else {
            error = 'Connection error or Network ID not found';
        }
    } catch(e) {
        error = 'Connection error';
    }

    return error;
};